module.exports = __webpack_public_path__ + "static/media/balon.808beae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/balon.jpg
// module id = 1288
// module chunks = 0